export const nameRegexForFeedback: RegExp =
  /^[a-zA-Zа-яієїґА-ЯҐЄІЇ]+(([' \\-][a-zA-Zа-яієїґА-ЯҐЄІЇ])?[a-zA-Zа-яієїґА-ЯҐЄІЇ]*)*$/;

export const nameRegex: RegExp =
  /^[а-яієїґА-ЯҐЄІЇ]+(([' \\-][а-яієїґА-ЯҐЄІЇ])?[а-яієїґА-ЯҐЄІЇ]*)*$/;

 export const emailRegex: RegExp = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

// A pure charset check (nameRegex above) lets keyboard-mash strings like
// "прппоп" or "орнегншгршг" through, since they're technically all valid
// Cyrillic letters. These two extra checks catch that: real Ukrainian names
// essentially never have 4+ consonants in a row (the longest real clusters —
// "Мстислав", "Дзвінка" — cap out at 3) and always contain at least one vowel.
export const containsVowelRegex: RegExp = /[аеєиіїоуюя]/i;

export const longConsonantRunRegex: RegExp =
  /[бвгґджзйклмнпрстфхцчшщ]{4,}/i;
